import { Navigate, Outlet } from 'react-router-dom'
import { useSeniorMode } from '../hooks/useSeniorMode'

/**
 * В senior mode /profile недоступен — редирект на dashboard.
 * На desktop useSeniorMode() возвращает false → guard пропускает.
 */
export function SeniorProfileGuard() {
  const { senior } = useSeniorMode()
  if (senior) return <Navigate to="/dashboard" replace />
  return <Outlet />
}
